import DisputeButton from "@features/vessel-call/vessel-call-status/Operations/flow/DisputeButton";
import NoDisputeButton from "@features/vessel-call/vessel-call-status/Operations/flow/NoDisputeButton";

interface OperationsDisputesFlowButtonsProps {
  onDispute?: () => void;
  onNoDispute?: () => void;
}

const OperationsDisputesFlowButtons = ({
  onDispute,
  onNoDispute,
}: OperationsDisputesFlowButtonsProps) => {
  return (
    <div className="flex gap-4">
      <DisputeButton onClick={onDispute} />
      <NoDisputeButton onClick={onNoDispute} />
    </div>
  );
};

export default OperationsDisputesFlowButtons;
